// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebDeleteFavoriteByIdsRequest,
  TWebDeleteFavoriteByIdsModel,
  IMappers,
  TWebDeleteFavoriteByIdsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IDefaultSuccessResponseSchema } from '../../../entities/delete_user_favorites/DefaultSuccessResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebDeleteFavoriteByIdsModel(
  parameters: TWebDeleteFavoriteByIdsRequest,
): TWebDeleteFavoriteByIdsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/web/delete-favorite-by-ids/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebDeleteFavoriteByIdsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebDeleteFavoriteByIdsRequest;
}

export async function fetchWebDeleteFavoriteByIds<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebDeleteFavoriteByIdsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebDeleteFavoriteByIdsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebDeleteFavoriteByIdsModel(parameters),
    config,
  )) as FetchResponse<TWebDeleteFavoriteByIdsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDefaultSuccessResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebDeleteFavoriteByIdsResponse>;
}
